import { Center, Stack, Text } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { AnnualReportAnalytics } from '@/module/AnnualReport/AnnualReportAnalytics';

import { PendingSpinner } from '@/core/components';

export const Route = createFileRoute('/_auth/report/_report/analytics')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'annualReport.title' },
  },
});

function RouteComponent() {
  return (
    <Suspense
      fallback={
        <Center mt="20%">
          <Stack>
            <Text
              fw="500"
              ta="center"
            >
              Se calculează informațiile cerute. Operația poate dura și câteva minute.
            </Text>
            <PendingSpinner h="10vh" />
          </Stack>
        </Center>
      }
    >
      <AnnualReportAnalytics />
    </Suspense>
  );
}
